import { h } from "vue"

const ACCENT_COLOR = "#4f7cff"

const parseMarkdownLink = (str) => {
  if (typeof str !== "string") return null
  const match = str.match(/\[([^\]]+)\]\(([^)]+)\)/)
  return match ? { text: match[1], url: match[2] } : null
}

const renderLink = (link) => {
  const parsed = parseMarkdownLink(link)
  if (!parsed) return null

  return () =>
    h(
      "a",
      {
        href: parsed.url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: `color: ${ACCENT_COLOR}; text-decoration: underline`
      },
      parsed.text
    )
}

export const showNotificationToast = (notification, payload) => {
  if (!payload || !payload.text) return

  notification.info({
    title: payload.title,
    content: payload.text,
    meta: payload.link ? renderLink(payload.link) : undefined,
    duration: 6000,
    closable: true,
    keepAliveOnHover: true
  })
}
